import { render, staticRenderFns } from "./gptd.vue?vue&type=template&id=18b34e72&scoped=true"
import script from "./gptd.vue?vue&type=script&lang=js"
export * from "./gptd.vue?vue&type=script&lang=js"
import style0 from "./gptd.vue?vue&type=style&index=0&id=18b34e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b34e72",
  null
  
)

export default component.exports